import { Routes } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { BlogDetailsComponent } from './blogs/blog-details/blog-details.component';
import { BlogLandingComponent } from './blogs/blog-landing/blog-landing.component';
import { BlogLandingTablesComponent } from './blogs/blog-landing-tables/blog-landing-tables.component';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: 'blogs',
    redirectTo: 'blogs/landing',
    pathMatch: 'full',
  },
  {
    path: 'blogs/landing',
    component: BlogLandingComponent,
    pathMatch: 'full',
  },
  {
    path: 'blogs/landing-tables',
    component: BlogLandingTablesComponent,
    pathMatch: 'full',
  },
  {
    path: 'about',
    component: AboutComponent,
    pathMatch: 'full',
  },
  {
    path: 'blogs/:id',
    component: BlogDetailsComponent,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
